import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConnectRestService } from '../services/connect-rest.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EnglishTranslation, MalayTranslation, ProductCode } from '../app.constants';
import { DataStoreService } from '../data-store.service';

declare var $: any;
@Component({
  selector: 'app-company-constitution',
  templateUrl: './company-constitution.component.html',
  styleUrls: ['./company-constitution.component.scss']
})
export class CompanyConstitutionComponent implements OnInit {

  constructor(
    private connect: ConnectRestService,
    private formBuilder: FormBuilder,
    public router: Router,
    private dataStoreService: DataStoreService
  ) {
  }

  CompanyConstitution: FormGroup;
  RefCCDL: any;
  BoardResolutionDate: any;
  FlowID: number;
  isSecondDirector: boolean = false;
  ConstitutionDetails: any = []
  textContent: any;
  boardResolutionLink: string;

  onSubmit() {
    // if (!this.isSecondDirector) {
    this.callSaveRequest();
    // } else {
    //   this.router.navigate(['/declaration']);
    // }
  }

  ngOnInit() {
    var langTranslation = sessionStorage.getItem("language");
    this.textContent = langTranslation == 'en-us' || langTranslation == undefined ? EnglishTranslation.CompanyConstitutuionScreen : MalayTranslation.CompanyConstitutuionScreen;
    var product = sessionStorage.getItem("currentProduct");

    if (product == ProductCode.eBizi) {
      this.boardResolutionLink = langTranslation == "ms" ? "https://www.ocbc.com.my/iwov-resources/my/ocbc/business/pdf/smes/accounts/ebiz-i/BM_OABB_Reso.pdf" : "assets/images/MY_Regional_Board_Resolution_14022024.pdf"
    } else { 
      this.boardResolutionLink = langTranslation == "ms" ? "https://www.ocbc.com.my/iwov-resources/my/ocbc/business/pdf/smes/accounts/ebiz/Board_Resolution_OBMB_BM.pdf" : "assets/images/MY_Regional_Board_Resolution_14022024.pdf"
    }

    this.FlowID = JSON.parse(sessionStorage.getItem('ServiceHeader')).Flow;
    if (this.FlowID == 2) {
      this.isSecondDirector = true;
      $(".radio-item").css("opacity", ".5");
    }
    this.buildForm();
    this.callReadRequest();

    $(document).ready(function () {
      //DCI update (15/7/2020): Disable keypress enter or other to navigate page
      $("form").bind("keypress", function (e) {
        if (e.keyCode == 13) {
          return false;
        }
      });
    });
    
  }

  async ngAfterViewInit() {
    if(await this.dataStoreService.getAAStatus()) {
      this.dataStoreService.setAAData('company-constitution');
    }
  }

  // (Begin) CJT 5Jun2020 to call connectRest Service Function
  async restConnect(data, reqID: String) {
    var ServResponse = await this.connect.connectRest(data, reqID, '');
    // this.connect.consoleLog('data value: R/S0100', data);
    return ServResponse;
  }
  // (End) CJT 05Jun2020


  async callReadRequest() {
    // (Begin) CJT 22Jun2020 to call Request R0100
    var data = {};
    const ServResponse = await this.restConnect(data, "R0100");
    if (ServResponse.Status == "Success") {
      this.ConstitutionDetails = ServResponse["ApplicantList"];
      this.setDataResponse(ServResponse);
    }
    else {
      //    console.log("Server Response: " + ServResponse.Status);
    }

    // (End) CJT 22Jun2020
  }

  setDataResponse(data) {
    var radioValue;
    if (data.NoConstitution !== null) {
      radioValue = String(data.NoConstitution);
    }
    this.BoardResolutionDate = data.BoardResolutionDate;
    this.CompanyConstitution.patchValue(
      {
        radio_declare: radioValue
      }
    )
    this.CompanyConstitution.updateValueAndValidity();
  }
  async callSaveRequest() {
    // (Begin) CJT 22Jun2020 to call Request S0100
    var data = {
      BoardResolutionDate: this.BoardResolutionDate,
      NoConstitution: this.CompanyConstitution.controls['radio_declare'].value,
      ConfirmAll: this.CompanyConstitution.controls['confirm_constitution'].value
    }
    var ServResponse = await this.restConnect(data, "S0100");
    if (ServResponse.Status == "Success") {
      this.router.navigate(['/declaration']);
    }
    else {
      //    console.log("Server Response: " + ServResponse.Status);
    }
    // (End) CJT 22Jun2020
  }

  buildForm() {
    this.CompanyConstitution = this.formBuilder.group({
      radio_declare: [{ value: '', disabled: this.isSecondDirector }, Validators.required],
      confirm_constitution: ['', [Validators.required, Validators.pattern('true')]]
    });

  }


}
